import React from 'react'
import "./available.css"

const Available = () => {
  return (
    <div className="box">
        <div className="available">
            <div className="round"></div>
            <p>Available For work</p>
        </div>
    </div>
  )
}

export default Available
